<template>
  <div class="chart_warp">
    <!-- <div class="node_mark_group">
      <div class="node_maer" v-for="n in 12" :style="{background: getColor(n, 'node') }"></div>
    </div> -->
    <!-- top标签 -->
    <div class="graph_tools_warp">
      <el-skeleton :rows="5" :loading="tabsLoading" animated style="width: 100%; height: 100%; padding: 0 16px;"
        v-show="tabsLoading" />
      <div class="tools_warp" v-if="!tabsLoading">
        <div class="tool_panel" v-for="item in sourceTabs" :key="item.labelValue">
          <div class="big_title">{{ item.name }}</div>
          <div class="tabs_thumbnail">
            <div class="tabs_group" v-for="tab in item.child" :key="tab.labelValue">
              <div class="tabs_item" :class="{ active: tab.selected, disabled: !tab.display }"
                @click="tabsClick(item, tab)">
                <div class="tabs_img">
                  <img :src="tabImg(tab)" alt="">
                </div>
                <p class="tabs_tips">{{ tab.name }}</p>
              </div>
              <div class="tabs_btns" v-if="tab.btns && tab.btns.length">
                <template v-for="btn in tab.btns">
                  <div class="tabs_btn"
                    :class="[`col${tab.btns.length}`, { disabled: btn.disabled, active: btn.selected }]"
                    @click="tabsClick(item, tab, btn)">{{ btn.name }}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- charts区域 -->
    <div class="dialog_chart_warp" :class="{ full: fullVisible }" v-loading="fullLoading">
      <!-- 工具栏 -->
      <div class="chart_tool">
        <span>{{ centerNode ? (centerNode.node?.label || centerNode.label) + '关系图谱' : '' }}</span>
        <div>
          <div class="charts_btn" @click="showDetailPanel">
            <img :src="require('@/assets/graph/icon_node.png')" alt="">
            <span>节点详情</span>
          </div>
          <div class="charts_btn" @click="fullScreen">
            <img :src="require('@/assets/graph/icon_full.png')" alt="">
            <span>{{ fullVisible ? '退出全屏' : '全屏查看' }}</span>
          </div>
          <div class="charts_btn" @click="downLoad">
            <img :src="require('@/assets/graph/icon_save.png')" alt="">
            <span>保存图片</span>
          </div>
          <!-- <div class="charts_btn">
            <img :src="require('@/assets/graph/icon_img.png')" alt="">
            <span>查看高清图</span>
          </div> -->
        </div>
      </div>
      <!-- 关系网 -->
      <div class="chart_cont_warp">
        <!-- 关系网区域 -->
        <div class="graph_panel">
          <GraphvisChart :ref="'graph_vis_' + chartName" :chart-name="chartName" @nodeClick="nodeClick"
            @openLoading="openLoading" />
        </div>
        <!-- 缩略图 -->
        <!-- <div class="chart_route" :class="{ active: showMini, full: fullVisible }" v-if="false">
          <div class="mini_view_panel" :class="{ active: showMini }">
            <i class="side_icon"
              :class="[showMini ? 'side_icon_hide el-icon-d-arrow-left' : 'side_icon_show el-icon-d-arrow-right']"
              :title="showMini ? '收起' : '展开'" @click="showMini = !showMini"></i>
            <div class="chart_img_panel" ref="chart_image_panel">
              <div class="panel_tool" @click="changeView()">
                <span class="chart_title"><i class="el-icon-back"></i></span>
                <span>返回至上级视图</span>
              </div>
              <div class="chart_img">
                <img ref="chart_image" :src="imageUrl" alt="">
              </div>
            </div>
          </div>
        </div> -->
        <!-- 展开路径 -->
        <div class="route_panel_warp" :class="{ full: fullVisible }" v-if="showOwn">
          <div class="panel_title">视图路径</div>
          <div class="route_group_panel" ref="route_panel">
            <div class="route_group" v-for="(item, index) in chartRoute" :key="index">
              <div class="route_slice" v-if="item.node">
                {{ item.node.path }}
              </div>
              <div class="route_text" :class="{ active: index == (chartRoute.length - 1) }"
                @click="changeView({ row: item, index: index }, 'route')">{{ item.node ? item.node.label : item.label }}
              </div>
            </div>
          </div>
        </div>
        <!-- 节点详情 -->
        <div class="node_detail_panel" :class="{ hide: !showDetail }" ref="detailPanel">
          <!-- 添加可拖拽的顶部边线 -->
          <div class="drag-handle" @mousedown="startDrag"></div>
          <div class="panel_btn" @click="showDetailPanel">
            <i :class="showDetail ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
            <span>{{ showDetail ? '收起' : '展开' }}节点详情</span>
          </div>
          <div class="panel_body" v-show="showDetail" v-loading="detailLoading">
            <div class="panel_content" v-if="paneType != ''">
              <div class="detail_panel">
                <div class="list_group" v-for="(item, index) in detailData" :key="index">
                  <div class="list_group_head">
                    <div class="group_head_title">
                      <div class="head_title">
                        <div class="title_warp">
                          <strong class="title_text">{{ item.name }}</strong>
                          <div class="title_label" v-if="paneType == '1' && item.isActive == 1">
                            <img :src="require('@/assets/hotspot.png')" />活跃
                          </div>
                        </div>
                        <div class="group_head_tool" v-if="paneType == '1'" style="{position:relative}">
                          平台评分&nbsp;&nbsp;<span class="head_tags_item">{{
                            item.totalScore == 0 ? '--' : item.totalScore > 100 ? 100 : item.totalScore
                          }}</span>
                        </div>
                      </div>
                      <div class="head_tags">
                        <el-tag size="small" v-for="(tag, t) in item.tags" :key="'ht_' + t">
                          {{ tagValue(tag) }}
                        </el-tag>
                      </div>
                    </div>
                  </div>
                  <div class="list_group_body">
                    <div class="group_item" v-for="(list, l) in item.list" :key="l">
                      <div class="group_item_filed">{{ list.label }}:</div>
                      <div class="group_item_value">{{ list.value }}</div>
                    </div>
                    <div class="tab_panel">
                      <div class="tab_title">关系类型</div>
                      <div class="tab_bar">
                        <div class="tab_item" v-for="(tab, t) in relations" :key="'tab_' + t">{{ tab.name }}({{ tab.cnt
                          }})</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table_panel">
                <div class="tabs_panel">
                  <el-tabs v-model="activePane">
                    <el-tab-pane :label="paneType == '1' ? '掌握资源情况' : paneType == '2' ? '终端关系网信息' : '渠道关系网信息'"
                      name="second">
                      <DetailTables ref="node_table" :paneType="paneType" :autoHeight="false" />
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
            <div class="panel_content" v-else>
              <div class="empty">
                <img class="empty_img" :src="require('@/assets/graph/pic_empty.png')" alt="">
                <p class="empty_text">暂无该节点详情数据</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 图例标识 -->
      <div class="chart_marks">
        <div class="mark_icon center">
          <span class="circel_mark"></span>
          <span>中心点</span>
        </div>
        <div v-for="n in nodeTypes" :key="n.type" class="mark_icon circel">
          <span class="circel_mark" :style="{ background: getColor(n.type, 'node') }"></span>
          <span>{{ n.name }}</span>
        </div>
        <!-- <div class="mark_icon" v-for="l in linkTypes" :key="l.name">
          <span class="line_mark" :style="{ background: getColor(l.name, 'line') }"></span>
          <span>{{ l.name }}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import PieGraphChart from './pieGraph.vue'
import GraphvisChart from './chartGraphvis.vue'
import DetailTables from '../../detailTables.vue';
import InfoTable from '../infoTable.vue';
import _ from 'lodash'

import {
  linkColor,
  getNodeColor,
  getLinkColor,
  getTargetColor,
  getLinkNet,
  typeFilter,
  getMedmiddleInfo,
  getTerminalInfo,
  getChannelInfo,
  setBaseInfo,
  getTopLabel,
  getLinkData,
  getServiceByTouch,
  getStartData,
} from '@/api/portrait.js'

export default {
  props: {
    chartName: String,
    detailType: String,
  },
  components: {
    PieGraphChart,
    GraphvisChart,
    InfoTable,
    DetailTables
  },
  data() {
    return {
      // 关系网数据
      graphData: {
        nodes: [],
        links: []
      },
      isCenter: false,
      tabsLoading: false,
      sourceTabs: [], // 标签列表
      activeTabs: null, // 当前点击的标签
      serviceTabs: null, // 选中的服务网络/供应网络数据
      currNode: null, // 当前节点
      currTabs: { list: [], selected: {} }, // 当前标签数据
      currMap: {}, // 当前数据集合 {‘1-1’: {nodes: [], links: []}, ‘1-2’: {nodes: [], links: []}
      centerNode: null, // 中心节点
      toDrill: false, // 是否下钻
      showOwn: false, // 是否显示下钻路径
      totalMap: [], // 所有数据集合
      chartRoute: [], // 下钻路径数据
      showDetail: false, // 是否显示节点详情
      detailData: [], // 节点详情数据
      paneType: '', // 节点详情类型
      activePane: 'second', // 节点详情激活的标签
      detailLoading: false, // 节点详情加载状态
      nodeList: [],
      fullLoading: false, // 全屏加载
      fullVisible: false, // 全屏显示
      overallNodeInfo: {}, // 全局节点信息
      nodeTypes: [], // 节点类型
      linkTypes: [], // 连线类型
      relations: [], // 节点详情关系统计
      // 网络类型配置
      netTypeConfig: {
        // 服务网络
        '1-1': { path: '服务网络：商业公司', image: 'fw_qy' },
        '1-2': { path: '服务网络：生产企业', image: 'fw_gs' },
        '1-3': { path: '服务网络：服务人员', image: 'fw_ry' },
        // 触达网络
        '2-1': { path: (val) => val === '2-1' ? '触达网络：医院' : val === '2-1-1' ? '触达网络：科室' : '触达网络：医生', image: { base: 'cd_yy', stateful: true } },
        '2-2': { path: '触达网络：药店', image: { base: 'cd_yd', stateful: true } },
        '2-3': { path: (val) => val === '2-3' ? '触达网络：商业公司' : val === '2-3-1' ? '触达网络：部门' : '触达网络：联系人', image: { base: 'cd_gs', stateful: true } },
        '2-4': { path: '触达网络：基层医疗', image: { base: 'cd_yl', stateful: true } },
        // 工作关系
        '3-1': { path: (val) => val === '3-1-1' ? '工作关系：上级' : val === '3-1-2' ? '工作关系：下级' : '工作关系：平级', image: 'gz_gx' },
        // 销售网络
        '4-1': { path: (val) => val === '4-1' ? '销售网络：商业公司' : val === '4-1-1' ? '销售网络：部门' : '销售网络：联系人', image: { base: 'cd_gs', stateful: true } },
        '4-2': { path: (val) => val === '4-2' ? '销售网络：医院' : val === '4-2-1' ? '销售网络：科室' : '销售网络：医生', image: { base: 'cd_yy', stateful: true } },
        '4-3': { path: '销售网络：药店', image: { base: 'cd_yd', stateful: true } },
        '4-4': { path: '销售网络：基层医疗', image: { base: 'cd_yl', stateful: true } },
        // 物流网络
        '5-1': { path: '物流网络：配送网络', image: 'wl_ps' },
        '5-2': { path: '物流网络：仓储网络', image: 'wl_cc' },
        // 供应网络
        '6-1': { path: '供应网络：生产企业', image: 'fw_qy' },
        '6-2': { path: '供应网络：商业公司', image: 'fw_gs' }
      },
      // tab的btn配置
      tabButtonConfigs: {
        '2-1': [
          { name: "科室", value: "1", disabledCheck: nodeType => nodeType !== '4' },
          { name: "医生", value: "2", disabledCheck: nodeType => !['4', '10'].includes(nodeType) }
        ],
        '4-2': [
          { name: "科室", value: "1", disabledCheck: nodeType => nodeType !== '4' },
          { name: "医生", value: "2", disabledCheck: nodeType => !['4', '10'].includes(nodeType) }
        ],
        '2-3': [
          { name: "部门", value: "1", disabledCheck: nodeType => nodeType !== '6' },
          { name: "联系人", value: "2", disabledCheck: nodeType => !['6', '11'].includes(nodeType) }
        ],
        '4-1': [
          { name: "部门", value: "1", disabledCheck: nodeType => nodeType !== '6' },
          { name: "联系人", value: "2", disabledCheck: nodeType => !['6', '11'].includes(nodeType) }
        ],
        '3-1': [
          { name: "上级", value: "1", disabledCheck: () => false },
          { name: "下级", value: "2", disabledCheck: () => false },
          // { name: "平级", value: "3", disabledCheck: () => false }
        ]
      },
      isDragging: false,
      startY: 0,
      startHeight: 0
    }
  },
  methods: {
    destroy() {
      this.$refs['graph_vis_' + this.chartName] && this.$refs['graph_vis_' + this.chartName].destroy();
    },
    /**
     * 根据行数据获取对应的图片
     * @param {Object} row - 行数据（必须包含labelValue和display属性）
     * @returns {String} - 图片路径或空字符串
    **/
    tabImg({ labelValue, display }) {
      const { image } = this.netTypeConfig[labelValue] || {};
      if (!image) return '';
      const imgPath = typeof image === 'string' ? image : `${image.base}${!display && '_disabled' || ''}`;
      try {
        return require(`@/assets/graph/${imgPath}.png`);
      } catch {
        return '';
      }
    },
    tagValue(row) {
      return typeFilter(row)
    },
    openLoading(flag) {
      if (flag) {
        if (!this.fullLoading) {
          this.fullLoading = true
        }
      } else {
        this.fullLoading = false
      }
    },
    fullScreen() {
      this.fullVisible = !this.fullVisible
      this.$nextTick(() => {
        this.$refs['graph_vis_' + this.chartName].chartResize();
      })
    },
    // 获取base64位图片
    downLoad() {
      this.$refs['graph_vis_' + this.chartName].saveImage();
    },
    async promiseList(tasks, endLoad = false) {
      !this.fullLoading && (this.fullLoading = true); // 开启全局加载动画

      try {
        await Promise.all(tasks.map(task => task())); // 执行所有传入的任务
        endLoad && (this.fullLoading = false)
      } catch (error) {
        // 可以在这里添加额外的错误处理逻辑
        this.fullLoading = false
      }
    },
    async setOption(val, params) {
      // 整个data重置
      Object.assign(this.$data, this.$options.data.call(this))
      // this.simpleData = _.cloneDeep(val)
      const node = val[0] || {};
      await this.initCurrentNode(node);
      this.loadVisGraph(params, node);
    },
    // 初始化当前节点数据
    initCurrentNode(node) {
      this.isCenter = true
      this.centerNode = _.cloneDeep(node);
      this.currNode = _.cloneDeep(node);
      const nodeInfo = {
        node: _.cloneDeep(node),
        tabs: { list: [], selected: {} },
        map: {},
      };
      this.chartRoute.push(nodeInfo);
    },
    // 加载graph数据
    loadVisGraph(params, node) {
      // 设置初始选中的tab
      const { labelValue: tabLabelValue, name: tabLabelName } = params.data;
      let tabValue = tabLabelValue, initSelectedTabs = {}, tabName = tabLabelName;
      initSelectedTabs[tabValue] = true;
      const centerType = this.centerNode.node?.type || this.centerNode.type;
      // 特殊处理人员节点的tab值
      if (centerType === '1' && tabLabelValue === '3-1') {
        tabValue = `${tabLabelValue}-3`;
        tabName = '平级';
        initSelectedTabs[tabValue] = true;
      }
      // 初始化节点数据
      this.activeTabs = { ...params.data, name: tabName, labelValue: tabValue };
      this.currTabs.selected = JSON.parse(JSON.stringify(initSelectedTabs));
      this.chartRoute[0].tabs.selected = JSON.parse(JSON.stringify(initSelectedTabs));
      // 获取节点数据
      this.promiseList([
        () => this.getTabs(true),
        () => this.getNodes()
      ]);
    },
    /**
     * 渲染图表
     * @param {string} chartId 图表ID
    **/
    async loadChart(chartId) {
      await this.$nextTick();
      const { id: centerId, type: centerType } = this.centerNode.node || this.centerNode;
      // 重置并初始化图表
      const chartRef = this.$refs[chartId];
      chartRef.destroy();
      Object.assign(chartRef, {
        graphData: _.cloneDeep(this.graphData),
        currCenter: _.cloneDeep(this.centerNode),
        currNode: _.cloneDeep(this.currNode),
        rootId: centerId,
        graphName: `graph_chart_${chartId}`
      });
      chartRef.setOption();
      // 处理节点类型和图例
      this.processNodeTypes(centerId, centerType);
    },
    /**
     * 处理节点类型和图例
     * @param {string} centerId 中心节点ID
     * @param {string} centerType 中心节点Type
    **/
    processNodeTypes(centerId, centerType) {
      const { nodes, links } = this.graphData;
      // 统计非中心节点的各类型数量
      let nodeTypeArr = [], nodeTypeList = [], linkTypeArr = [], linkTypeList = [];
      // 获取节点类型
      nodes.forEach(n => {
        if (n.id != centerId && nodeTypeArr.indexOf(n.type) == -1) {
          nodeTypeArr.push(n.type);
          nodeTypeList.push({ name: getNodeColor(Number(n.type)).name, type: n.type })
        } else {
          return
        }
      })
      // 获取连线类型
      // links.forEach(l => {
      //   if (linkTypeArr.indexOf(l.label) == -1) {
      //     linkTypeArr.push(l.label);
      //     linkTypeList.push({ name: l.label, type: getLinkNet(l.label) })
      //   } else {
      //     return
      //   }
      // })

      // 生成图例数据
      this.nodeTypes = nodeTypeList.sort((a, b) => Number(a.type) - Number(b.type));
      // this.linkTypes = linkTypeList.sort((a, b) => Number(a.type) - Number(b.type));
    },
    // 设置图例样式
    getColor(name, type) {
      if (type == 'node') {
        return getNodeColor(Number(name)).color;
      } else {
        return `rgb(${linkColor[getLinkColor(name)].selectedColor})`;
      }
    },
    /**
     * 获取标签数据
     * vertexType说明：
     * 1:服务人员 2:医生 3:联系人 4:医院 5:药店 6:商业公司
     * 7:基层医疗 8:生产企业 9:产品 10:科室 11:部门 12:生产商
     * 特殊处理类型: 2:医生 3:联系人 10:科室 11:部门
    **/
    async getTabs(isInit = false) {
      const currNode = this.currNode.node || this.currNode;
      const param = {
        damId: currNode.damId,
        vertexType: currNode.type,
        ...(this.isCenter && { linkType: this.detailType }),
        ...(currNode.type === '6' && { isSaas: currNode.isSaas })
      };

      this.tabsLoading = true;

      try {
        const res = await getTopLabel(param);
        if (!res.data) {
          this.$message('暂无该节点标签数据', { duration: 3000 });
          // this.setChartRoutes(false);
          return;
        }

        const list = res.data.labels || [];
        const tabsObj = {};
        list.forEach(item => {
          item.child.forEach(c => {
            // 设置默认选中状态
            c.selected = this.currTabs.selected?.[c.labelValue] ?? false;
            // 特殊处理隐藏逻辑
            if ((c.labelValue === '2-1' && ['2', '10'].includes(currNode.type)) ||
              (c.labelValue === '2-3' && ['3', '11'].includes(currNode.type))) {
              c.display = false;
            }
            // 处理按钮配置
            if (['2-1', '4-2', '2-3', '4-1', '3-1'].includes(c.labelValue)) {
              c.btns = this.generateTabButtons(c.labelValue, currNode.type);
              c.btns.map(b => tabsObj[b.labelValue] = b);
            }
            tabsObj[c.labelValue] = c;
          });
        });
        // 更新状态
        this.sourceTabs = list;
        this.currTabs.list = _.cloneDeep(list);
        isInit && (this.chartRoute[0].tabs.list = _.cloneDeep(list));
      } catch (error) {
        console.error('获取标签出错:', error);
        // this.setChartRoutes(false);
      } finally {
        this.tabsLoading = false;
      }
    },
    // 获取节点数据
    async getNodes() {
      try {
        const nodeData = this.currNode.node || this.currNode
        // 构建请求参数
        const param = {
          damId: nodeData.damId,
          vertexType: nodeData.type,
          selectedLabel: {
            labelName: this.activeTabs.name,
            labelValue: this.activeTabs.labelValue
          }
        };
        // SAAS类型特殊处理
        if (nodeData.type === '6') {
          param.isSaas = nodeData.isSaas;
        }
        // 获取数据
        const res = await getLinkData(param);
        const { nodes: rawNodes = [], links: rawLinks = [] } = res.data || {};
        const nodes = rawNodes || [];
        const links = rawLinks || [];
        // 更新节点数据
        this.setNodeData(nodes, links);
      } catch (error) {
        console.error('获取节点数据失败:', error);
        this.openLoading(false);
        // this.setChartRoutes();
      }
    },
    // 设置top标签
    setSourceTabs(tabs) {
      if (!tabs || !Array.isArray(tabs)) return;
      tabs.forEach(item => {// 网络层
        item.child.forEach(tc => {
          tc.selected = this.currTabs.selected[tc.labelValue] == undefined ? false : this.currTabs.selected[tc.labelValue]
          if (tc.btns) {
            tc.btns.forEach(b => {
              if (!b.disabled) {
                b.selected = this.currTabs.selected[b.labelValue] == undefined ? false : this.currTabs.selected[b.labelValue]
              }
            })
          }
        })
      })
      this.sourceTabs = tabs
    },
    // 设置视图路径滚动至当前节点
    setChartRoutes(toPop = true) {
      const currType = this.currNode.node?.type || this.currNode.type;
      const currId = this.currNode.node?.id || this.currNode.id;
      const currCenterId = this.centerNode.node?.id || this.centerNode.id;
      if (currId != currCenterId && toPop) {
        if (currType != '2' && currType != '10' && currType != '3' && currType != '11') {
          this.chartRoute.at(-1).id == this.currNode.id && this.chartRoute.pop()
        }
      }
    },
    // 生成标签按钮配置
    generateTabButtons(labelValue, nodeType) {
      return (this.tabButtonConfigs[labelValue] || []).map(btn => ({
        name: btn.name,
        labelValue: `${labelValue}-${btn.value}`,
        disabled: btn.disabledCheck(nodeType),
        selected: this.currTabs.selected[`${labelValue}-${btn.value}`] ?? false
      }));
    },
    // 节点数据处理
    setNodeData(nodeData, linkData) {
      /**
       * 中心节点与选中节点相同：剔除selectedTabs中false的数据
       * 中心节点与选中节点不同：
       *  1.中心节点为医院/商业公司：
       *    a.选中节点为医生/联系人/科室/部门: 不下钻
       *    b.选中节点为其他：下钻
       *  2.中心节点为其他：下钻
      **/
      const currData = this.currNode.node || this.currNode
      const centerData = this.centerNode.node || this.centerNode
      if (currData.id == centerData.id) {// 中心节点与选中节点相同
        let datas = [], links = []
        if (nodeData.length) {
          datas = this.setNodeStyle(nodeData, this.activeTabs.labelValue)
          links = this.setEdgeStyle(linkData)
        } else {
          datas = this.graphData.nodes.filter(item => item.id == currData.id)
          links = []
        }
        const currNodeData = datas.find(d => d.id == currData.id);
        this.currMap[this.activeTabs.labelValue] = { nodes: datas, links: links }
        this.setOptionSeries(datas, links)
        this.chartRoute.at(-1).node = JSON.parse(JSON.stringify(currNodeData || currData));
        this.chartRoute.at(-1).map = JSON.parse(JSON.stringify(this.currMap));
        this.chartRoute.at(-1).tabs.selected = JSON.parse(JSON.stringify(this.currTabs.selected));
      } else {// 中心节点与选中节点不同
        if (this.toDrill) {
          this.centerNode = _.cloneDeep(this.currNode);
        }
        let datas = this.setNodeStyle(nodeData, this.activeTabs.labelValue)
        let links = this.setEdgeStyle(linkData)
        this.graphData.nodes = datas
        this.graphData.links = links
        const currNodeData = datas.find(d => d.id == currData.id);
        this.currMap[this.activeTabs.labelValue] = { nodes: datas, links: links }
        this.loadChart('graph_vis_' + this.chartName)
        if (this.toDrill) {
          const lastRoute = this.totalMap.at(-1);
          const lastNodeId = lastRoute.node ? lastRoute.node.id : lastRoute.id;
          if (lastNodeId == currData.id) {
            const nodeInfo = {
              node: JSON.parse(JSON.stringify(currNodeData || currData)),
              map: JSON.parse(JSON.stringify(this.currMap)),
              tabs: _.cloneDeep(this.currTabs),
            };
            this.totalMap[this.totalMap.length - 1] = nodeInfo;
            this.chartRoute.push(nodeInfo);
            this.$nextTick(() => {
              this.changeViewRoute();
            })
          }
        }
      }
    },
    // 重置数据
    async resetData(infoData, selectTab) {
      const allSelectTabGraphData = {
        links: [],
        nodes: []
      }
      // 获取已有节点数据
      selectTab.forEach(s => {
        const tabGraphData = _.cloneDeep(infoData[s] || null);
        if (tabGraphData) {
          allSelectTabGraphData.links.push(...tabGraphData.links)
          allSelectTabGraphData.nodes.push(...tabGraphData.nodes)
        }
      });
      // 数据去重
      this.graphData.links = [];
      this.graphData.nodes = [];
      await this.resetOption(allSelectTabGraphData.nodes, allSelectTabGraphData.links);
      // 若无节点则显示当前节点
      if (this.graphData.nodes.length == 0) {
        const node = this.currNode.node || this.currNode;
        this.graphData.nodes.push(node)
      }
    },
    // 合并去重
    async setOptionSeries(data, link, load = true) {
      await this.resetOption(data, link)
      // 更新视图
      if (load) {
        this.loadChart('graph_vis_' + this.chartName)
      } else {
        let nodeInfo = this.currMap[this.activeTabs.labelValue]
        if (nodeInfo && nodeInfo.nodes.length) {
          this.setOptionSeries(nodeInfo.nodes, nodeInfo.links)
        } else {
          this.promiseList([
            () => this.getNodes()
          ]);
        }
      }
    },
    // 设置option
    resetOption(data = [], link = []) {
      return new Promise((resolve) => {
        // 不需要cloneDeep，直接修改原graphData
        const { nodes = [], links = [] } = this.graphData
        // 合并节点数据
        const mergedNodes = [...nodes] // 浅拷贝即可
        data.forEach(item => {
          if (!mergedNodes.some(d => d.id === item.id)) {
            mergedNodes.push(item)
          }
        })
        // 合并连接数据
        const mergedLinks = [...links] // 浅拷贝即可
        link.forEach(item => {
          if (!mergedLinks.some(l =>
            l.source === item.source && l.target === item.target
          )) {
            mergedLinks.push(item)
          }
        })
        // 直接更新原graphData
        this.graphData.nodes = mergedNodes
        this.graphData.links = mergedLinks
        resolve()
      })
    },
    // 数组 reduce 删除
    arrReduceDelete(originArr, targetArr) {
      return new Promise((resolve, reject) => {
        let data = originArr.reduce((acc, cur) => {
          let index = null
          let target = acc.find((e, i) => {
            if ((cur.id && e.id == cur.id) || (cur.source && e.source == cur.source && e.target == cur.target)) {
              index = i
              return true
            } else {
              return false
            }
          })
          if (target) {
            acc.splice(index, 1)
          }
          return acc
        }, targetArr)
        targetArr = data
        resolve()
      })
    },
    /**
     * 设置节点样式
     * @param {Array} nodes 节点数组
     * @param {String} type 节点类型
     * @returns {Array} 处理后的节点数组
    **/
    setNodeStyle(nodes, type) {
      const center = this.centerNode.node || this.centerNode;
      return nodes.map(item => {
        const nodeItem = { ...item };
        const isCenter = item.id === center.id;
        nodeItem.path = isCenter ? center.path : this.getNodePath(type);
        return nodeItem;
      });
    },
    /**
     * 获取非中心节点路径
     * @private
    **/
    getNodePath(type) {
      if (!type) return '';
      const tabKey = type.substring(0, 3); // 取前3位作为key
      const config = this.netTypeConfig[tabKey];
      if (!config || !config.path) return '';
      return typeof config.path === 'function' ? config.path(type) : config.path;
    },
    // 设置边线样式
    setEdgeStyle(edges) {
      let newEdges = []
      const centerData = this.centerNode.node || this.centerNode;
      newEdges = edges.map((edge, e) => {
        let edgeItem = {
          ...edge,
          type: getTargetColor(edge.rel_type, edge.label == '触达网络'? centerData.type : edge.label == '物流网络'? edge.labelName : edge.label == '销售网络' ? {type: edge.labelName, isCenter: edge.target == centerData.id} : null)
          // type: 'default'
        }
        return edgeItem
      })
      return newEdges
    },
    // 节点点击事件 选中/取消 选中节点则获取节点对应的tab信息 若节点tab数据存在则直接显示，若不存在则调用接口获取
    nodeClick(model) {
      // 设置加载状态
      this.tabsLoading = true;
      try {
        // 重置视图状态
        this.resetNodeState();
        // 设置当前节点
        const centerId = this.centerNode.node?.id || this.centerNode.id;
        const nodeId = model?.id || centerId;
        const nodeInfo = model && nodeId != centerId ? {} : this.chartRoute.at(-1) || {}
        this.currNode = model && nodeId != centerId ? { ...model.properties } : nodeInfo.node;
        this.currTabs = nodeInfo?.tabs || { list: [], selected: {} };
        this.currMap = nodeInfo?.map || {};

        if (!model || nodeId === centerId) {// 中心节点点击处理
          if (this.currTabs.list?.length) {
            const tabs = this.processTabs(JSON.parse(JSON.stringify(this.currTabs.list)));
            this.sourceTabs = tabs;
          }
        } else {// 普通节点点击处理
          if (!this.currTabs.list?.length) {
            this.getTabs();  // 直接调用getTabs获取数据
          } else {
            const tabs = this.processTabs(JSON.parse(JSON.stringify(this.currTabs.list)));
            this.sourceTabs = tabs;
          }
        }
      } catch (error) {
        console.error('节点点击出错:', error);
      } finally {
        this.tabsLoading = false;
      }
    },
    // 重置视图状态数据
    resetNodeState() {
      Object.assign(this, {
        showDetail: false,
        isCenter: false,
        activeTabs: null,
        serviceTabs: null,
        // routeChanged: false
      });
    },
    // 处理标签选中状态
    processTabs(tabs) {
      if (!Array.isArray(tabs)) return tabs;
      return tabs.map(item => ({
        ...item,
        child: item.child?.map(child => ({
          ...child,
          selected: child.labelValue == '3-1' ? (this.currTabs.selected?.[`${child.labelValue}-3`] ?? false) : (this.currTabs.selected?.[child.labelValue] ?? false),
          btns: child.btns?.map(btn =>
            btn.disabled ? btn : {
              ...btn,
              selected: this.currTabs.selected?.[btn.labelValue] ?? false
            }
          )
        }))
      }));
    },
    // top标签点击事件
    async tabsClick(row, tab, btn) {
      this.showDetail = false
      this.toDrill = false;
      if ((!btn && !tab.display) || (btn && btn.disabled)) return
      this.openLoading(true)
      // console.log('this', this)
      const nodeId = this.currNode.node?.id || this.currNode.id || ''
      const centerId = this.centerNode.node?.id || this.centerNode.id || ''
      const nodeData = this.currNode.node || this.currNode;
      // tab标签样式
      await this.setTabSelected(row, tab, btn, nodeData);
      const isSelected = btn ? btn.selected : tab.selected;
      const { selectTab } = this.getSelectTabs();
      // 获取当前节点已存储信息
      let currNodeInfo = this.chartRoute.at(-1);
      // 当前节点不为科室医生部门联系人时 设置下钻
      if (isSelected && nodeId != centerId) {
        if (nodeData.type != '2' && nodeData.type != '10' && nodeData.type != '3' && nodeData.type != '11') {
          this.showOwn = true // 显示下钻路径
          this.toDrill = true;
          const routeNode = JSON.parse(JSON.stringify(currNodeInfo));
          let centerNode = JSON.parse(JSON.stringify(this.centerNode.node || this.centerNode));
          if (this.chartRoute.length > 1) {
            centerNode.node = routeNode.node
          }
          this.totalMap.push(centerNode);
          this.totalMap.push(_.cloneDeep(this.currNode));
        }
      }
      if (!this.toDrill) {
        currNodeInfo.tabs.selected = JSON.parse(JSON.stringify(this.currTabs.selected));
      }

      // 获取选中且无节点数据的tab
      const noGraphDataTab = selectTab.filter(s => !this.currMap[s.labelValue]);
      // 获取未请求过的节点数据
      const getUnacquiredData = async () => {
        noGraphDataTab.forEach(n => {
          this.activeTabs = btn ? { ...btn, ...n } : { ...tab, ...n };
          this.promiseList([
            () => this.getNodes()
          ]);
        })
      }

      // 若无选中tab的数据 则获取
      if (isSelected) {
        if (noGraphDataTab.length) {
          getUnacquiredData();
        } else {
          this.activeTabs = btn ? { ...btn } : { ...tab, ...(tab.labelValue == '3-1' && { name: '平级', labelValue: '3-1-3' }) };
          const { nodes: datas, links } = this.currMap[this.activeTabs.labelValue];
          this.setOptionSeries(datas, links);
        }
      } else {
        this.graphData = { ...this.$options.data().graphData };
        this.graphData = this.generateGraphData();
        if (btn && row.labelValue != '3') {
          if (noGraphDataTab.length) {
            getUnacquiredData();
          } else {
            this.loadChart('graph_vis_' + this.chartName)
          }
        } else {
          this.loadChart('graph_vis_' + this.chartName)
        }
      }
    },
    // 设置tab切换的选中状态
    setTabSelected(row, tab, btn, nodeData) {
      if (btn) {
        tab.btns.forEach(b => {
          // 1. 处理当前按钮的选中状态切换
          const isCurrentBtn = b.labelValue === btn.labelValue;
          b.selected = isCurrentBtn ? !b.selected : b.selected || false;

          // 2. 处理层级关联关系
          if (isCurrentBtn) {
            if (tab.labelValue === '2-1') { // 医院触达网络
              if (btn.labelValue === '2-1-1' && !b.selected) { // 取消选中科室
                // 取消所有医生
                tab.btns
                  .filter(dBtn => dBtn.labelValue === '2-1-2')
                  .forEach(dBtn => dBtn.selected = false);
              } else if (btn.labelValue === '2-1-2' && b.selected) { // 选中医生
                // 确保科室被选中
                const deptBtn = tab.btns.find(d => d.labelValue === '2-1-1');
                if (deptBtn) {
                  deptBtn.selected = true;
                  this.currTabs.selected['2-1-1'] = true;
                }
              }
            } else if (tab.labelValue === '2-3') { // 商业公司触达网络
              if (btn.labelValue === '2-3-1' && !b.selected) { // 取消选中部门
                // 取消所有联系人
                tab.btns
                  .filter(cBtn => cBtn.labelValue === '2-3-2')
                  .forEach(cBtn => cBtn.selected = false);
              } else if (btn.labelValue === '2-3-2' && b.selected) { // 选中联系人
                // 确保部门被选中
                const deptBtn = tab.btns.find(d => d.labelValue === '2-3-1');
                if (deptBtn) {
                  deptBtn.selected = true;
                  this.currTabs.selected['2-3-1'] = true;
                }
              }
            }
          }

          // 3. 更新currTabs选中状态
          if (b.selected) {
            this.currTabs.selected[b.labelValue] = true;
          } else {
            delete this.currTabs.selected[b.labelValue];
          }
        })
      } else {
        // 节点不是科室、医生、部门、联系人 或者 节点是科室/医生/部门/联系人但不是触达网络
        if ((nodeData.type != '2' && nodeData.type != '10' && nodeData.type != '3' && nodeData.type != '11') ||
          (row.labelValue != '2' && (nodeData.type == '2' || nodeData.type == '10' || nodeData.type == '3' || nodeData.type == '11'))) {
          // 更新当前网络下的child选中状态
          this.updateChildTabs(row, tab);
        }
      }
    },
    // 工具函数：更新工作关系网的按钮状态（默认选中平级）
    updateWorkRelationBtns(item, tab) {
      const isSelected = item.selected;
      const targetBtnLabel = `${tab.labelValue}-3`; // 平级的labelValue格式（如3-1-3）
      item.btns?.forEach(btn => {
        btn.selected = isSelected ? (btn.labelValue === targetBtnLabel) : btn.selected || false;
        if (btn.selected) {
          this.currTabs.selected[btn.labelValue] = btn.selected;
        } else {
          delete this.currTabs.selected[btn.labelValue];
        }
        btn.labelValue === targetBtnLabel && btn.selected && (this.activeTabs.name = '平级', this.activeTabs.labelValue = '3-1-3');
      });
    },
    // 工具函数：更新当前网络下的child选中状态
    updateChildTabs(row, tab) {
      row.child.forEach(item => {
        item.selected = item.labelValue === tab.labelValue ? !item.selected : item.selected || false;
        if (item.labelValue == '3-1') {
          if (item.selected) {
            this.currTabs.selected[`${item.labelValue}-3`] = item.selected;
          } else {
            delete this.currTabs.selected[`${item.labelValue}-3`];
          }
        } else {
          if (item.selected) {
            this.currTabs.selected[item.labelValue] = item.selected;
          } else {
            delete this.currTabs.selected[item.labelValue];
          }
        }

        // // 处理工作关系网的按钮（row.labelValue == 3）
        // if (row.labelValue === '3') {
        //   this.updateWorkRelationBtns(item, tab);
        // }
      });
    },
    // 根据已有数据和选中项获取关系数据
    generateGraphData() {
      let selected = {};
      const currSelected = this.currTabs.selected;
      for (var s in currSelected) {
        if (s !== '3-1') selected[s] = currSelected[s];
      }
      const datas = { nodes: [], links: [] };
      const nodeIds = new Set(); // 用于去重节点
      const linkKeys = new Set(); // 用于去重连接

      if (Object.keys(selected).length == 0) {
        datas.nodes.push(this.currNode)
      } else {
        // 遍历selected对象
        Object.entries(selected).forEach(([key, isSelected]) => {
          if (isSelected && this.currMap[key]) {
            const { nodes = [], links = [] } = this.currMap[key];

            // 添加节点（去重）
            nodes.forEach(node => {
              if (!nodeIds.has(node.id)) {
                nodeIds.add(node.id);
                datas.nodes.push(node);
              }
            });

            // 添加连接（去重）
            links.forEach(link => {
              const linkKey = `${link.source}-${link.target}`;
              if (!linkKeys.has(linkKey)) {
                linkKeys.add(linkKey);
                datas.links.push(link);
              }
            });
          }
        });
      }
      return datas;
    },
    // 获取选中的tab
    getSelectTabs(selectTabs, aTab = false) {
      let selectTab = [], sTabVal = '', actTabVal = '';
      if (selectTabs) {
        for (var s in selectTabs) {
          if (selectTabs[s]) {
            if (/^(3-1)/.test(s) && s !== '3-1') {
              selectTab.push(s)
            } else {
              selectTab.push(s)
              if (aTab && /^(2-|4-)/.test(s)) {
                actTabVal = s
              }
            }
          } else {
            if (/^(1-|6-)/.test(s)) {
              sTabVal = s;
            }
          }
        }
      } else {
        const tabList = _.cloneDeep(this.sourceTabs);
        const traverse = (items) => {
          if (!items || !Array.isArray(items)) return;

          items.forEach(item => {
            // 检查当前元素的selected状态
            if (item.selected === true) {
              if (/^(3-1)/.test(item.labelValue)) {
                selectTab.push({ name: item.labelValue == '3-1' ? '平级' : item.name, labelValue: item.labelValue == '3-1' ? `${item.labelValue}-3` : item.labelValue })
              } else {
                selectTab.push({ name: item.name, labelValue: item.labelValue })
                if (/^(2-|4-)/.test(item.labelValue)) {
                  actTabVal = item.labelValue
                }
              }
            } else {
              if (/^(1-|6-)/.test(item.labelValue)) {
                sTabVal = item.labelValue;
              }
            }

            // 递归检查子元素
            if (item.child) {
              traverse(item.child);
            }

            // 检查btns数组
            if (item.btns) {
              traverse(item.btns);
            }
          });
        };

        traverse(tabList);
      }

      return { selectTab, sTabVal, actTabVal }
    },
    // 更新小视图
    async changeView(info, type) {
      this.showDetail = false;
      let index = 0;
      if (type == 'route') {
        index = info.index
      } else if (type == 'view_route') {
        index = this.chartRoute.length - this.viewRoutes.length + info.index
      } else {
        index = this.chartRoute.length - 2
      }
      if (index == (this.chartRoute.length - 1)) return;
      let nodeData = this.chartRoute.at(-2);
      if (info) {
        nodeData = this.chartRoute[info.index]
      }
      const nodeInfo = _.cloneDeep(nodeData)
      this.centerNode = _.cloneDeep(nodeInfo.node);
      this.currNode = _.cloneDeep(nodeInfo.node);
      this.currTabs = _.cloneDeep(nodeInfo.tabs);
      this.currMap = _.cloneDeep(nodeInfo.map);
      const tabs = this.processTabs(JSON.parse(JSON.stringify(nodeInfo.tabs.list)));
      this.sourceTabs = tabs;
      this.chartRoute.splice(index + 1);
      // this.totalImages.splice(index);
      this.$nextTick(() => {
        this.changeViewRoute();
      })
      if (index == 0) {
        this.showOwn = false
      } else {
        // 更新小视图
        // this.imageUrl = this.totalImages[index - 1]
      }

      // 数据处理
      this.graphData = { ...this.$options.data().graphData };
      this.graphData = this.generateGraphData();
      // 更新主视图
      this.loadChart('graph_vis_' + this.chartName)
    },
    // 视图路径区域滚动到选中路径处
    changeViewRoute() {
      let dom = this.$refs.route_panel;
      if (dom) {
        dom.scrollTo({ top: dom.scrollHeight, behavior: 'smooth' });
      }
    },
    setTabs(arr, sTabs) {
      arr.forEach(i => {
        i.selected = sTabs ? (sTabs[i.labelValue] || false) : false;
        if (i.child && i.child.length > 0) {
          i.child = this.setTabs(i.child, sTabs)
        }
        if (i.btns && i.btns.length > 0) {
          i.btns = this.setTabs(i.btns, sTabs)
        }
      })
      return arr
    },
    // 显示详情面板
    showDetailPanel() {
      let params = { pageSize: 10, pageIndex: 1 }, type = ''
      const currType = this.currNode.node?.type || this.currNode.type;
      const currDamid = this.currNode.node?.damId || this.currNode.damId;
      if (currType == '1') {
        type = '1'
        params.idCard = currDamid
      } else {
        if (currType == '4' || currType == '5' || currType == '7') {
          type = '2'
        } else if (currType == '6') {
          type = '3'
        }
        params.damId = currDamid
      }
      this.paneType = type
      if (type != '') {
        this.showDetail = !this.showDetail
        if (this.detailData.length) {
          if ((type == '1' && this.detailData[0].idCard == currDamid) || (type != '1' && this.detailData[0].damId == currDamid)) {
            return
          }
        }
        if (this.showDetail) {
          this.getDetailData(params, type)
        }
      } else {
        this.showDetail = false
        this.$message('暂无该节点详情数据', { duration: 3000 })
        this.detailData = []
      }
    },
    // 获取搜索结果
    async getDetailData(params, type) {
      // 配置映射表
      const configMap = {
        '1': { // 人员
          method: () => getMedmiddleInfo(params),
          labelName: 'user',
          starTypes: [1, 2, 3],
          idValue: params.idCard  // 人员使用idCard
        },
        '2': { // 终端
          method: () => getTerminalInfo(params),
          labelName: 'terminal',
          starTypes: [4, 5, 6],
          idValue: params.damId    // 终端使用damId
        },
        '3': { // 渠道
          method: () => getChannelInfo(params),
          labelName: 'company',
          starTypes: [7, 8, 9],
          idValue: params.damId    // 渠道使用damId
        }
      };
      const config = configMap[type];
      if (!config) return;
      try {
        this.detailLoading = true;
        // 准备请求数组
        const requests = [
          config.method(),
          ...config.starTypes.map(type =>
            getStartData({
              idValue: config.idValue,
              labelName: config.labelName,
              type
            })
          )
        ];
        const [mainRes, ...starRes] = await Promise.all(requests);
        this.detailLoading = false;
        // 处理主数据
        this.detailData = (mainRes.data.records || []).map(item =>
          setBaseInfo(item, type)
        );
        // 处理关联数据
        this.relations = starRes.reduce((acc, res) => {
          return [...acc, ...(res.data?.nodes?.[0]?.relations || [])];
        }, []);
      } catch (err) {
        console.error('获取详情失败:', err);
        this.detailLoading = false;
      } finally {
        // 初始化表格
        this.$nextTick(() => {
          this.$refs.node_table.initTable(false);
          this.$refs.node_table.idCard = config.idValue;
          this.$refs.node_table.getGraphTable(params);
        });
      }
    },
    // 开始拖拽
    startDrag(e) {
      this.isDragging = true;
      this.startY = e.clientY;
      this.startHeight = this.$refs.detailPanel.offsetHeight;

      document.addEventListener('mousemove', this.handleDrag);
      document.addEventListener('mouseup', this.stopDrag);
      e.preventDefault();
    },
    // 拖拽过程处理
    handleDrag(e) {
      if (this.isDragging) {
        const deltaY = this.startY - e.clientY;
        const newHeight = this.startHeight + deltaY;

        // 设置最小和最大高度限制
        const minHeight = 150; // 最小高度
        const maxHeight = window.innerHeight * 0.85; // 最大高度为视口的70%

        // 应用新高度，同时限制在最小和最大值之间
        this.$refs.detailPanel.style.height =
          Math.min(maxHeight, Math.max(minHeight, newHeight)) + 'px';
      }
    },
    // 停止拖拽
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.handleDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    }

  }
}
</script>

<style lang="less" scoped>
.graph_tools_warp {
  width: 100%;
  height: 200px;
}

.tools_warp {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: auto hidden;
}

.graph_panel {
  width: 100%;
  height: 100%;
  position: relative;

  >div {
    position: absolute;
    top: 0;
    left: 0;
  }
}

.chart_warp {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow: hidden;

  .chart_cont {
    width: 100%;
    height: 100%;
  }
}

.node_detail_panel {
  width: 100%;
  height: 360px;
  background: #fff;
  position: fixed;
  bottom: 0;
  z-index: 33;

  &.hide {
    height: 0 !important;
  }

  .drag-handle {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    cursor: ns-resize;
    z-index: 10;
    background-color: transparent;
    transition: background-color 0.2s;
  }

  .drag-handle:hover {
    background-color: #409EFF;
  }

  .panel_btn {
    width: 124px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #FFFFFF;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px 2px 0px 0px;
    border-bottom-color: #fff;
    position: absolute;
    top: -38px;
    right: 2px;
    cursor: pointer;

    >i {
      margin-right: 4px;
    }
  }

  &.active {
    // bottom: 0;
  }

  >.panel_header {
    height: 38px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #666;

    >div {
      display: flex;
      align-items: center;
    }

    i {
      font-size: 20px;
      cursor: pointer;

      &.header_btn_icon {
        font-size: 16px;
        margin-left: 5px;
      }
    }
  }

  >.panel_body {
    width: 100%;
    height: 100%;

    .panel_content {
      width: 100%;
      height: 100%;
      display: flex;
      box-shadow: 0 0 0 1px #d9d9d9;
      background-color: #fff;
      overflow: hidden;
      position: relative;

      .empty {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .empty_img {
          height: 180px;
        }

        .empty_text {
          font-size: 14px;
          color: #BDBDBD;
          margin: 0;
          line-height: 30px;
          text-align: center;
        }
      }
    }

    .detail_panel {
      width: 320px;
      font-size: 12px;
      color: #666;
      line-height: 24px;

      .list_group {
        height: 100%;
        padding: 12px 12px 0;
        overflow: hidden auto;
        position: relative;

        .list_group_head {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          .group_head_title {
            width: 100%;
            text-align: left;

            .head_title {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;

              .title_warp {
                display: flex;
                align-items: center;
              }

              .title_text {
                font-size: 18px;
                color: #212121;
                letter-spacing: 0;
                line-height: 27px;
                font-weight: 600;
                margin-right: 10px;
              }

              .title_label {
                width: 60px;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                color: #FF8831;
                background: #FFF9F5;
                border-radius: 10px;

                >img {
                  width: 20px;
                  height: 18px;
                  margin: -2px 2px 0 4px;
                  vertical-align: middle;
                }
              }
            }

            .head_tags {
              .el-tag {
                background-color: #f5f5f5;
                color: #404040;
                border-color: #f5f5f5;
                margin-right: 5px;
              }
            }
          }

          .group_head_tool {
            font-size: 12px;
            color: #666;
            line-height: 30px;

            .head_tags_item {
              font-size: 20px;
              color: #FF5F1F;
              font-weight: 500;
              vertical-align: bottom;
            }

            button.tips_icon {
              margin-left: 10px;
              background-color: #666;
              border-color: #666;
              color: #fff;
              font-size: 16px;
              padding: 2px !important;
            }

            .gred_panel {
              width: 360px;
              position: absolute;
              top: 3.5rem;
              left: -150%;
              background: #fff;
              padding: 5px;
              border: 1px solid #ddd;
              border-radius: 4px;
              box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
              text-align: left;
              transition: all 0.3s;

              &::after {
                right: 14px;
                border-width: 9px;
                border-bottom-color: #fff;
              }

              .list_title {
                color: #212121;
                padding: 0 5px;
                border-bottom: 1px solid #EBEEF5;
                margin-bottom: 5px;
              }

              .list_panel {
                display: flex;
                justify-content: space-between;

                .el-statistic {
                  width: 100%;
                  text-align: center;

                  .head {
                    color: #666;
                    font-size: 12px;
                  }

                  .con .number {
                    color: #FF5F1F;
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }

        .list_group_body {
          margin-bottom: 12px;

          .group_item {
            display: flex;

            .group_item_filed {
              width: 80px;
            }

            .group_item_value {
              width: calc(100% - 90px);
            }
          }
        }
      }

      .list_group_btns {
        margin-top: 10px;
        border-top: 1px solid #e5e5e5;

        .btns_title {
          margin: 10px 0;
        }

        .btns_list {
          .tags_bths {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            color: #666;
            font-size: 12px;
            line-height: unset;

            .tags_bth {
              padding: 0 12px;
              background-color: #FAFAFA;
              border: 1px solid #d9d9d9;
              border-radius: 2px;
              margin: 0 5px 5px 0;
              cursor: pointer;

              &.active,
              &:hover {
                background-color: #EBF6F7;
                border-color: #4FA1A4;
                color: #4FA1A4;
              }
            }
          }
        }
      }
    }

    .table_panel {
      width: calc(100% - 320px);
      border-left: 1px solid #e5e5e5;

      .tabs_panel {
        padding: 0 12px 12px;

        .el-tabs {
          height: calc(100% - 12px);

          .el-tabs__active-bar {
            background-color: #4FA1A4;
          }

          .el-tabs__item {
            font-size: 12px;
            color: #666;

            &.is-active {
              color: #4FA1A4;
            }
          }
        }

        .el-tabs__content {
          height: calc(100% - 52px);
        }
      }

      .pan_list_panel {
        display: flex;
        flex-wrap: wrap;

        .list_col {
          width: calc(33.33% - 8px);
          line-height: 1;
          cursor: pointer;
          color: #404040;
          padding: 8px 4px;
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          &:hover {
            color: #4FA1A4;
          }
        }
      }
    }
  }
}

.detail_panel {
  .list_group {
    display: flex;
    flex-direction: column;
    padding: 0 !important;
    overflow: hidden !important;

    .list_group_head {
      padding: 10px 10px 0;
    }

    .list_group_body {
      flex: 1;
      padding: 0 10px 10px;
      margin-bottom: 0 !important;
      overflow: hidden auto;

      .group_item {
        width: 100%;

        .group_item_value {
          width: calc(100% - 80px);
        }
      }

      .tab_title {
        margin-top: 8px;
        padding: 4px 0;
        border-top: 1px solid #d9d9d9;
      }

      .tab_panel {
        .tab_bar {
          display: flex;
          flex-wrap: wrap;
          margin-right: -5px;

          .tab_item {
            width: calc(33.33% - 10px);
            text-align: center;
            margin: 0 5px 5px 0;
            border: 1px solid #d9d9d9;
            border-radius: 2px;
          }
        }
      }
    }
  }
}

.table_panel {
  /deep/.table_warp {
    .el-table {
      height: calc(100% - 34px) !important;
    }

    .table_page {
      height: 34px;
    }
  }
}

/deep/.dialog_chart_warp {
  .el-loading-mask {
    background-color: rgba(255, 255, 255, .75) !important;
  }
}

.chart_marks {
  width: 100%;
  height: 44px;
  padding: 0 12px;
  font-size: 14px;
  color: #666;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;

  .mark_icon {
    display: flex;
    align-items: center;
    padding: 0;
    margin-right: 16px;

    .circel_mark {
      display: block;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      margin-right: 4px;
    }

    &.center {
      .circel_mark {
        background: #3317b7;
      }
    }

    .line_mark {
      display: block;
      width: 27px;
      height: 4px;
      background: #46A5FF;
      margin-right: 4px;
    }
  }
}
</style>
